import { render, staticRenderFns } from "./moveOrder.vue?vue&type=template&id=ddb27aec&scoped=true&"
import script from "./moveOrder.vue?vue&type=script&lang=js&"
export * from "./moveOrder.vue?vue&type=script&lang=js&"
import style0 from "./moveOrder.vue?vue&type=style&index=0&id=ddb27aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb27aec",
  null
  
)

export default component.exports